var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.metrics.policyViolationsTotal === 0
    ? _c(
        "span",
        { staticClass: "progress" },
        [
          _c(
            "b-progress",
            {
              staticClass: "table-progress",
              attrs: { max: "0", "show-value": "" },
            },
            [
              _c("b-progress-bar", {
                staticClass: "table-progress text-dark",
                attrs: { value: "0" },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "span",
        { staticClass: "progress" },
        [
          _c(
            "span",
            {
              staticClass: "table-progress",
              attrs: { id: "progressbar" + _vm.hoverId },
            },
            [
              _c(
                "b-progress",
                {
                  staticClass: "table-progress",
                  attrs: {
                    max: _vm.metrics.policyViolationsTotal,
                    "show-value": "",
                  },
                },
                [
                  _c("b-progress-bar", {
                    staticClass: "severity-info-bg text-dark",
                    attrs: { value: _vm.metrics.policyViolationsInfo },
                  }),
                  _c("b-progress-bar", {
                    staticClass: "severity-warn-bg text-dark",
                    attrs: { value: _vm.metrics.policyViolationsWarn },
                  }),
                  _c("b-progress-bar", {
                    staticClass: "severity-fail-bg",
                    attrs: { value: _vm.metrics.policyViolationsFail },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tooltip",
            {
              attrs: {
                target: "progressbar" + _vm.hoverId,
                placement: "left",
                noninteractive: "",
              },
            },
            [
              _c("div", { staticStyle: { "text-align": "left" } }, [
                _c("h5", [_vm._v(_vm._s(_vm.$t("message.type")))]),
                _c("p", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("policy_violation.license")) +
                      ":\n        " +
                      _vm._s(_vm.metrics.policyViolationsLicenseTotal)
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("policy_violation.operational")) +
                      ":\n        " +
                      _vm._s(_vm.metrics.policyViolationsOperationalTotal)
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("policy_violation.security")) +
                      ":\n        " +
                      _vm._s(_vm.metrics.policyViolationsSecurityTotal)
                  ),
                  _c("br"),
                ]),
                _c("h5", [_vm._v(_vm._s(_vm.$t("message.violation_state")))]),
                _c("p", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("policy_violation.infos")) +
                      ": " +
                      _vm._s(_vm.metrics.policyViolationsInfo)
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("policy_violation.warns")) +
                      ": " +
                      _vm._s(_vm.metrics.policyViolationsWarn)
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("policy_violation.fails")) +
                      ": " +
                      _vm._s(_vm.metrics.policyViolationsFail)
                  ),
                  _c("br"),
                ]),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("message.total")) +
                    ": " +
                    _vm._s(_vm.metrics.policyViolationsTotal) +
                    "\n    "
                ),
              ]),
            ]
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }